import PropTypes from 'prop-types';
import styles from './FJImageInputTwo.module.less';
import UploadCircleIcon from '../../../assets/svg/upload-circle.svg?react';
import UploadVideoIcon2 from '../../../assets/base64/video-input.js';
import FJLocalStore from '../../../store/FJLocalStore';
import { useRef, useCallback, useState } from 'react';
import UploadBorder265Icon from '../../../assets/svg/upload-border-265.svg?react';
import UploadBorder265HoverIcon from '../../../assets/svg/upload-border-265-hover.svg?react';
import UploadBorder80Icon from '../../../assets/svg/upload-border-80.svg?react';
import UploadBorder80HoverIcon from '../../../assets/svg/upload-border-80-hover.svg?react';
import UploadImgIcon from '../../../assets/svg/upload-img.svg?react';
import FJLoading from '../FJLoading/FJLoading';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil';
import FJEvent from '../../../store/FJEvent';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';
import FJMessageStore from '../../../store/FJMessageStore';
import FJConstant from '../../../constants/FJConstant';
import FJButton, { FJButtonType } from '../FJButton/FJButton.jsx';

const FJImageInputTwo = props => {
    const {
        uploadImg,
        acceptFile,
        openMediaLibrary,
        btnText = 'upload-image',
        icon,
        text = 'click-or-drag-to-upload',
        smallText = 'upload-image',
        smallIcon,
        tipsText = 'upload-up-to-20-images-at-once',

        isLoading = false,
        isSmallComponent = false,
        disabled = false,
        rightDraggingFile = false,
        multiple = false,
        isShowTips = false,
        isIconRight = false,
        isUploadVideoFile = false,

        isJudgeLogin = false, // 是否判断登录

        uploadBeforeCallback, // 点击弹出文件选择框前回调

        className,
        btnClassName,
    } = props;

    const [isDraggingFile, setIsDraggingFile] = useState(false);
    const inputRef = useRef(null);
    const [isClickLoading, setIsClickLoading] = useState(false);

    const _onUploadImg = useCallback(
        e => {
            const files = e.target.files;
            if (files && files.length > 0 && multiple) {
                uploadImg(files);
            } else if (files && files.length > 0 && !multiple) {
                uploadImg(files[0]);
            }
            e.target.value = null;
        },
        [uploadImg, multiple],
    );

    const _onUpload = useCallback(async () => {
        if (disabled || isClickLoading) {
            return;
        }

        if (uploadBeforeCallback) {
            uploadBeforeCallback();
        }

        setIsClickLoading(true);
        const isLocalhost = FJUtil.isLocalhost();
        if (isJudgeLogin && !isLocalhost) {
            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                },
            });
            if (userSpaceType > 0) {
                FJEvent.dispatch(FJConstant.USER_SPACE_CHANGE, userSpaceType);
                setIsClickLoading(false);
                return;
            }
        }
        setTimeout(() => {
            if (window.isEditPage && openMediaLibrary) {
                openMediaLibrary();
            } else if (inputRef.current) {
                inputRef.current.click();
            }
            setIsClickLoading(false);
        }, 0);
    }, [disabled, isJudgeLogin, isClickLoading]);

    const _onDragOver = useCallback(
        e => {
            e.stopPropagation();
            e.preventDefault();
            setIsDraggingFile(true);
        },
        [setIsDraggingFile],
    );

    const _onDragLeave = useCallback(
        e => {
            e.stopPropagation();
            e.preventDefault();
            setIsDraggingFile(false);
        },
        [setIsDraggingFile],
    );

    const _onDragDrop = useCallback(
        e => {
            e.stopPropagation();
            e.preventDefault();
            setIsDraggingFile(false);
            let files = e.dataTransfer.files;

            if (files && files.length > 0 && multiple) {
                uploadImg(files);
            } else if (files && files.length > 0 && !multiple) {
                uploadImg(files[0]);
            }
        },
        [uploadImg, setIsDraggingFile],
    );

    const mouseDownPanel = useCallback(() => {
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
    }, []);

    return (
        <div
            className={classNames(styles.input_box, className, {
                [styles.small_component]: isSmallComponent,
                [styles.dragging]: isDraggingFile || rightDraggingFile,
                [styles.disabled]: disabled,
            })}
            onDragOver={_onDragOver}
            onDrop={_onDragDrop}
            onDragLeave={_onDragLeave}
            onMouseDown={mouseDownPanel}
        >
            <div className={styles.upload_border_box}>
                {!isSmallComponent ? (
                    <>
                        <UploadBorder265Icon className={styles.upload_border_icon} />
                        <UploadBorder265HoverIcon className={styles.upload_border_icon_hover} />
                    </>
                ) : (
                    <>
                        <UploadBorder80Icon className={styles.upload_border_icon} />
                        <UploadBorder80HoverIcon className={styles.upload_border_icon_hover} />
                    </>
                )}
            </div>

            <div
                className={classNames(styles.content_box, {
                    [styles.small_component_content_box]: isSmallComponent,
                    [styles.hide]: isLoading,
                })}
                onClick={_onUpload}
            >
                {!isSmallComponent ? (
                    <>
                        {isUploadVideoFile ? (
                            <img src={UploadVideoIcon2} alt='' className={styles.upload_video_icon} />
                        ) : (
                            <UploadImgIcon className={styles.upload_img_icon} />
                        )}

                        <div className={styles.text}>{FJLocalStore._(text)}</div>
                        {isShowTips && (
                            <div className={styles.tips}>{FJLocalStore._(tipsText)}</div>
                        )}
                        <FJButton
                            className={classNames(styles.btn, btnClassName)}
                            type={FJButtonType.GRADIENT}
                            textClassName={styles.btn_text}
                            text={FJLocalStore._(btnText)}
                            isIconRight={isIconRight}
                            rightIcon={icon}
                        />
                    </>
                ) : (
                    <>
                        <UploadCircleIcon className={styles.upload_img_icon} />
                        <div className={styles.text}>{FJLocalStore._(smallText)}</div>
                        {smallIcon}
                    </>
                )}
            </div>

            {isLoading && (
                <div className={styles.loading}>
                    <FJLoading strokeColor='#a8acbc' />
                </div>
            )}

            <input
                type='file'
                ref={inputRef}
                multiple={multiple}
                className={styles.file_input}
                accept={acceptFile}
                onChange={_onUploadImg}
            />
        </div>
    );
};
FJImageInputTwo.propTypes = {
    openMediaLibrary: PropTypes.func,
    uploadImg: PropTypes.func,
    acceptFile: PropTypes.string,
    isLoading: PropTypes.bool,
    isSmallComponent: PropTypes.bool,
    disabled: PropTypes.bool,
    rightDraggingFile: PropTypes.bool,
};
export default FJImageInputTwo;
